/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import moment from 'moment'
import {KTCard} from '../../../../../../../_metronic/helpers'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {InputDate} from '../../../../../components/UI/Input'
import {Select} from '../../../../../components/UI/Select'
import {useKhipu} from '../../../../../hooks/useKhipu'
import {SelectOption} from '../../../../../models/utility.model'
import {ratioCheckinoutSchema} from '../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {useModules} from '../../../hooks/useModules'
import {
  RatioCheckInOutDto,
  RatioCheckinOutCompanyColumn,
  RatioCheckinOutData,
  RatioCheckinOutEnterpriseColumn,
} from '../../../models/reports.model'
import {getRatioCheckInOutService} from '../../../services/ratio.service'
import {TableReportRatioCheckinoutWrapper} from './Tables/TableReportRatioCheckinout'
import {TableReportRatioCheckinoutCompanyWrapper} from './Tables/TableReportRatioCheckinoutCompany'
import {TableReportRatioCheckinoutEnterpriseWrapper} from './Tables/TableReportRatioCheckinoutEnterprise'

const RatiosCheckInOut: FC = () => {
  const methods = useForm<RatioCheckInOutDto>({
    resolver: yupResolver(ratioCheckinoutSchema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      CampamentoId: '',
      ModuloId: '',
    },
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    watch,
    reset,
  } = methods
  const [compani, setCompany] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [client, setClient] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [site, setSite] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [camp, setCamp] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [modules, setModules] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [loading, setLoading] = useState<boolean>(false)
  const [dataCheckout, setDataCheckout] = useState<RatioCheckinOutData[]>([])
  const [dataEnterprise, setDataEnterprise] = useState<RatioCheckinOutEnterpriseColumn[]>([])
  const [dataCompany, setDataCompany] = useState<RatioCheckinOutCompanyColumn[]>([])
  const [siteSelected, setSiteSelected] = useState<string | null>(null)
  const [dtoToSend, setDtoToSend] = useState<any>()
  const [total, setTotal] = useState<number>(0)

  const {searchValues} = useKhipu()

  const {getModules} = useModules()
  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()
  ///
  ///

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCompany(allData)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})

      await getSitesFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setClient(allData)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      setSiteSelected(data[0].value as string)
      await getCampsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setSite(allData)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
      await getModulesFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCamp(allData)
  }

  const getModulesFn = async (campId: string) => {
    const data = await getModules({CampamentoId: campId})
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setModules(allData)
  }

  useEffect(() => {
    getCompaniesFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getRatios = async (datafilter: any = null) => {
    try {
      setLoading(true)
      const obj = {...(watch() as any)}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const formValue = {pageNumber: 1, size: 10, ...obj, ...searchValues, ...datafilter}
      setDtoToSend(formValue)
      const {data: response} = await getRatioCheckInOutService(formValue)
      if (!response.error) {
        setDataCheckout(response.data)
        let totalItemEnterprise: RatioCheckinOutEnterpriseColumn = {
          Descripcion: response.EmpresaTotal,
          TotalCheckInProgramados: response.Emp_TotalCheckInProgramados,
          TotalCheckInRealizados: response.Emp_TotalCheckInRealizados,
          TotalCheckOutProgramados: response.Emp_TotalCheckOutProgramados,
          TotalCheckOutRealizados: response.Emp_TotalCheckOutRealizados,
          RatioCheckIn: response.Emp_RatioCheckIn,
          RatioCheckOut: response.Emp_RatioCheckOut,
          RatioCheckInPorc: response.Emp_RatioCheckInPorc,
          RatioCheckOutPorc: response.Emp_RatioCheckOutPorc,
        }
        let arrEnterprise =
          response.dataEmp.length > 0
            ? [...response.dataEmp, totalItemEnterprise]
            : response.dataEmp
        setDataEnterprise(arrEnterprise)
        let totalItemCompany: RatioCheckinOutCompanyColumn = {
          Descripcion: response.CampamentoTotal,
          TotalCheckInProgramados: response.Camp_TotalCheckInProgramados,
          TotalCheckInRealizados: response.Camp_TotalCheckInRealizados,
          TotalCheckOutProgramados: response.Camp_TotalCheckOutProgramados,
          TotalCheckOutRealizados: response.Camp_TotalCheckOutRealizados,
          RatioCheckIn: response.Camp_RatioCheckIn,
          RatioCheckOut: response.Camp_RatioCheckOut,
          RatioCheckInPorc: response.Camp_RatioCheckInPorc,
          RatioCheckOutPorc: response.Camp_RatioCheckOutPorc,
        }
        let arrCompany =
          response.dataCamp.length > 0
            ? [...response.dataCamp, totalItemCompany]
            : response.dataCamp
        setDataCompany(arrCompany)
        setTotal(response.total)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const onSubmit = (dataForm: any) => {
    getRatios()
  }

  const handleChangeDateIni = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaIni', value)
    setError('FechaIni', {})
  }

  const handleChangeDateFin = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaFin', value)
    setError('FechaFin', {})
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    getClientsFn(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
    setClient([])
    setSite([])
    setCamp([])
    setModules([])
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    getSitesFn(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
    setSite([])
    setCamp([])
    setModules([])
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    getCampsFn(value)
    setValue('SiteId', value)
    setError('SiteId', {})
    setSiteSelected(value)
    setCamp([])
    setModules([])
  }

  const handleFilterModule = (e: any) => {
    let value = e.value
    setValue('ModuloId', '')
    getModulesFn(value)
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
    setModules([])
  }

  const handleClear = () => {
    reset()
    setClient([{value: '', label: 'TODOS'}])
    setSite([{value: '', label: 'TODOS'}])
    setCamp([{value: '', label: 'TODOS'}])
    setModules([{value: '', label: 'TODOS'}])
    setDataCheckout([])
    setDataCompany([])
    setDataEnterprise([])
    setSiteSelected(null)
    setDtoToSend(null)
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Compañía:</label>
                  <Select
                    control={control}
                    name='CompaniaId'
                    data={compani}
                    errors={errors}
                    onChangeValue={handleFilterClient}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Cliente:</label>
                  <Select
                    control={control}
                    name='ClienteId'
                    data={client}
                    errors={errors}
                    onChangeValue={handleFilterSite}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Site:</label>
                  <Select
                    control={control}
                    name='SiteId'
                    data={site}
                    errors={errors}
                    onChangeValue={handleFilterCamp}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Campamento:</label>
                  <Select
                    control={control}
                    name='CampamentoId'
                    data={camp}
                    errors={errors}
                    onChangeValue={handleFilterModule}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Módulo:</label>
                  <Select control={control} name='ModuloId' data={modules} errors={errors} />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Fecha Inicio de Reserva:</label>
                  <InputDate
                    name='FechaIni'
                    register={register}
                    errors={errors}
                    minValue={moment().subtract(1, 'month').format('YYYY-MM-DD')}
                    onChange={handleChangeDateIni}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label className='required'>Fecha Fin de Reserva:</label>
                  <InputDate
                    name='FechaFin'
                    register={register}
                    errors={errors}
                    onChange={handleChangeDateFin}
                  />
                </div>
              </div>
              {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
              <ButtonWrapper className={'sdx-white-bg'}>
                <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                <Button label='Limpiar' onClick={handleClear} />
                {/* <Button label='Exportar' onClick={handleExport} /> */}
              </ButtonWrapper>
            </form>
          </FormProvider>
        </div>
        <div className='sdx_content_tab_panel'>
          <Tabs className={'sdx_sub_react_tab_panel '}>
            <TabList className={'sdx_sub_tab_panel p-0'}>
              <Tab className={'sdx_sub_tab_panel_option'}>Check In/Out</Tab>
              <Tab className={'sdx_sub_tab_panel_option'}>Empresa</Tab>
              <Tab className={'sdx_sub_tab_panel_option'}>Campamento</Tab>
            </TabList>
            <TabPanel>
              <TableReportRatioCheckinoutWrapper
                datos={dataCheckout}
                loading={loading}
                getRatios={getRatios}
                siteSelected={siteSelected}
                formValue={dtoToSend}
                total={total}
              />
            </TabPanel>
            <TabPanel>
              <TableReportRatioCheckinoutEnterpriseWrapper
                datos={dataEnterprise}
                loading={loading}
                formValue={dtoToSend}
              />
            </TabPanel>
            <TabPanel>
              <TableReportRatioCheckinoutCompanyWrapper
                datos={dataCompany}
                loading={loading}
                formValue={dtoToSend}
              />
            </TabPanel>
          </Tabs>
        </div>
      </KTCard>
    </>
  )
}

export {RatiosCheckInOut}
